<template>
  <div>
    <div class="form-box">
      <div class="top-box">
        <a @click="preTab" class="back" v-if="currentTab > 0 && currentTab!=2">
          <i class="el-icon-back"></i>
        </a>
        <!-- <a @click="nextTab(null)" class="back" style="margin-left: 10px;" v-if="currentTab < 4">
          <i class="el-icon-right"></i>
        </a> -->
        <span style="flex: 1"></span>
        <!-- <a @click="goBack" class="close">
          <i class="el-icon-close"></i>
        </a> -->
      </div>
      <div class="slide-box">
        <div>
          <div :key="0" style="width: 100%; padding: 0 20px" v-if="currentTab==0">
            <LoginForm 
              :fromPage="'checkout'"
              @loginSuccess="handleLoginSuccess"
              @smsSuccess="handleSmsSuccess"
              @gotCode="handleGotCode"
              @needBindPhone="handleNeedBindPhone"
            />
          </div>

          <!-- 填写验证码 登录 -->
          <div :key="1" v-if="currentTab==1">
            <h2>Enter 4 digit code</h2>
            <p>
              Your code was sent to <br />
              <span class="under-line">{{ form.code }} {{ form.phone }}</span>
            </p>
            <div class="ver-code">
              <input
                v-if="currentTab==1"
                v-model="form.verCode"
                name=""
                type="digital"
                @focus="inputFocus = true"
                @blur="inputFocus = false"
                @keyup="form.verCode = form.verCode.substring(0, 4)"
                autofocus="autofocus"
                placeholder="Verification Code"
              />
              <div class="mask-box">
                <span class="font-box" v-for="(item, ind) in 4" :key="ind">
                  {{ form.verCode[ind] }}
                  <span
                    class="ol-line"
                    v-if="ind == form.verCode.length"
                  ></span>
                </span>
              </div>
            </div>
            <div :class="['resend-btn',{'disabled':!canGetCode}]" @click="showCaptcha(true)" >{{ sendPhonecode }}</div>
            <div
              :class="[
                'sign-btn',
                'flex-row-center',
                'confirm-btn',
                { 'disable-btn': !cantLogin },
              ]"
              @click="login"
            >
              Confirm
            </div>
          </div>

          <!-- 验证token - 弹层形式显示 -->
          <div v-if="showCloudflare" class="cloudflare-modal">
            <div class="cloudflare-overlay" @click="closeCloudflare"></div>
            <div class="cloudflare-content">
              <div class="cloudflare-header">
                <h3>Security Verification</h3>
                <button class="close-btn" @click="closeCloudflare">
                  <i class="el-icon-close"></i>
                </button>
              </div>
              <CloudflareVerify 
                style="padding: 20px;" 
                ref="cloudflare"
                @token-received="onTokenReceived"
              ></CloudflareVerify>
            </div>
          </div>

          <!-- 忘记密码弹窗 -->
          <ForgotPassword 
            v-if="showForgotPasswordModal"
            @close="closeForgotPassword"
          ></ForgotPassword>

          <!-- 绑定手机号 -->
          <div :key="2" v-if="currentTab==2">
            <BindPhone 
              :fromPage="'checkout'"
              @bindDone="handleBindDone"
            />
          </div>

          <!-- 补充姓名邮箱 -->
          <div :key="3" v-if="currentTab==3">
            <h2>
              Enter your <br />
              Name & Email
            </h2>
            <p class="name-tips">
              Please enter email to get <br />
              order confirmation and offers
            </p>
            <div class="form-line">
              <input type="text" name="" v-model="form.nickName" placeholder="Name" v-if="currentTab==3">
            </div>
            <div class="form-line">
              <input type="text" name="" v-model="form.email" placeholder="Email" v-if="currentTab==3">
            </div>
            <div
              style="width: 400px; margin: 20px auto 0;border-radius: 29px;"
              :class="[
                'sign-btn',
                'flex-row-center',
              ]"
              @click="submitNameInfo"
            >
              Submit
            </div>
          </div>

          <!-- 搜索地址 -->
          <div :key="4" v-if="currentTab==4">
            <h2 v-if="$isUk">
              Searching <br />
              Post code
            </h2>
            <h2 v-else>
              Searching <br />
              Eircode
            </h2>
            <div class="swtich-box" v-if="$isUk" >
              <el-tooltip class="item" effect="dark" content="Can't find your address? Try to open this mode. your address try open this mode" placement="top-start">
                <span>
                  Open Google Mode
                  <i class="el-icon-warning" ></i>
                </span>
              </el-tooltip>
              
              <el-switch
                v-model="useGoogleSearch"
                active-text=""
                inactive-text=""
                active-color="#aa0cc0"
                >
              </el-switch>
            </div>
            <div class="form-address-line">
              <div class="input-address-box" >
                <i class="el-icon-location "></i>
                <input type="text"  v-model="keywords" :placeholder="`Enter Your ${$isUk?'Post code':'Eircode'}`" name=""
                  v-if="currentTab==4"
                  @input="inputNow"
                  @keyup="inputNow"
                  @focus="focusNow = true"
                  @blur="focusNow = false"
                >
              </div>
              <div class="search-btn" >
                <img src="@/assets/images/search.png" class="el-icon-search" />
                <span class="text">Find Address</span>
              </div>
              <!-- 搜索结果内容 -->
              <div :class="['expand-box', { 'expand-box-active': (keywords && focusNow || resultList.length) }]">
                <div
                  class="search-item"
                  v-for="(item, ind) in resultList"
                  :key="ind"
                  @click="normalSearch(item)"
                >
                  <span style="font-size: 16px;">{{ item.content }}</span>
                  <i class="el-icon-loading" v-if="itemLoading == item.place_id && item.type=='location'"></i>
                  <img v-else src="@/assets/images/right.png" alt="right-arrow" />
                </div>
                <div class="load-box" v-if="loading">
                  <span class="loader"></span>
                </div>
                <div class="load-box" style="height: 50%;" v-else-if="!loading && !resultList.length">
                  No data.
                  <div class="empty-btn" > Can't find your address? Try to open this mode. your location? <br /> Try to type street name </div>
                </div>
                
              </div>
            </div>
          </div>

          <!-- 添加地址 -->
          <div :key="5" v-if="currentTab==5">
            <h2>
              Enter your Delivery Details
            </h2>
            <template v-if="this.$isUk">
              <!-- <h3 :class="['edit-form-title',{'empty-emptyTipsShaing-animate': showEmpty && !addressSearchForm.formattedAddress}]" >
                Address <span class="req-star">*</span>
              </h3>
              <div class="edit-form-line">
                <input type="text" name="" v-if="currentTab==5" v-model="addressSearchForm.formattedAddress" placeholder="Apartment, London Road ">
              </div> -->
              <div class="normal-form-line" style="margin: 0px auto 20px;flex-direction:column;align-items:stretch;height:auto;" >
                <h3 :class="['edit-form-title',{'empty-emptyTipsShaing-animate': showEmpty && !saveAddressForm.doorNumber && !saveAddressForm.dontDoorNum }]" style="width: 100%;">Door Number <span v-if="!saveAddressForm.dontDoorNum" class="req-star">*</span></h3>
                <div class="edit-form-line" style="width: 100%;">
                  <input type="text" name="" v-if="currentTab==5" v-model="saveAddressForm.doorNumber" :disabled="saveAddressForm.dontDoorNum" placeholder="Flat/Door/House Number">
                </div>
                <div class="normal-form-line">
                  <el-checkbox style="margin-left:5px;" size="medium" v-model="saveAddressForm.dontDoorNum"></el-checkbox>
                  <span class="check-tips" style="cursor:pointer;" @click="saveAddressForm.dontDoorNum=!saveAddressForm.dontDoorNum">I Don’t Have A Door Number</span>
                </div>
                <!-- Mobile keeps Street standalone; PC pairs Street + Postcode -->
                <h3 v-if="isMobile" :class="['edit-form-title',{'empty-emptyTipsShaing-animate': showEmpty && !addressSearchForm.locationName }]" style="width: 100%;">Street / Road  <span class="req-star">*</span></h3>
                <div v-if="isMobile" class="edit-form-line" style="width: 100%;">
                  <input type="text" name="" v-if="currentTab==5" v-model="addressSearchForm.locationName" placeholder="Street / Road">
                </div>
              </div>

              <!-- PC：Street + Postcode 同一行 -->
              <div class="normal-form-line" v-if="!isMobile" style="height: 65px;margin: 0px auto 20px;" >
                <div style="flex:1;min-width: 58%;">
                  <h3 :class="['edit-form-title',{'empty-emptyTipsShaing-animate': showEmpty && !addressSearchForm.locationName }]" style="width: 100%;">Street / Road <span class="req-star">*</span></h3>
                  <div class="edit-form-line" style="width: 100%;">
                    <input type="text" name="" v-if="currentTab==5" v-model="addressSearchForm.locationName" placeholder="Street / Road" />
                  </div>
                </div>
                <span style="flex:1;" ></span>
                <div style="flex:1;min-width: 40%;">
                  <h3 :class="['edit-form-title',{'empty-emptyTipsShaing-animate': showEmpty && !addressSearchForm.zipcode}]" style="width: 100%;">Postcode <span class="req-star">*</span></h3>
                  <div class="edit-form-line" style="width: 100%;">
                    <input style="min-width:120px;" type="text" name="" v-if="currentTab==5" v-model="addressSearchForm.zipcode" placeholder="Postcode" />
                  </div>
                </div>
              </div>
              <!-- Mobile：Postcode 单独一行 -->
              <div class="normal-form-line" v-if="isMobile">
                <span :class="['check-tips',{'empty-emptyTipsShaing-animate': showEmpty && !addressSearchForm.zipcode}]" style="margin-right: 12px;margin-left: 0;">Postcode <span class="req-star">*</span></span>
                <span class="shadow-box" >
                  <input type="text" name="" v-if="currentTab==5" v-model="addressSearchForm.zipcode" placeholder="Postcode" />
                </span>
              </div>
              <!-- Mobile：City 单独一行 -->
              <div class="normal-form-line" v-if="isMobile" style="margin: 0px auto 20px;flex-direction:column;align-items:stretch;height:auto;" >
                <h3 :class="['edit-form-title',{'empty-emptyTipsShaing-animate': showEmpty && !addressSearchForm.city }]" style="width: 100%;">City <span class="req-star">*</span></h3>
                <div class="edit-form-line" style="width: 100%;">
                  <input type="text" name="" v-if="currentTab==5" v-model="addressSearchForm.city" placeholder="City">
                </div>
              </div>

              <!-- PC：City + Country 同一行 -->
              <div class="normal-form-line" v-if="!isMobile" style="height: 65px;margin: 0px auto 20px;" >
                <div style="flex:1;min-width: 58%;">
                  <h3 :class="['edit-form-title',{'empty-emptyTipsShaing-animate': showEmpty && !addressSearchForm.city }]" style="width: 100%;">City <span class="req-star">*</span></h3>
                  <div class="edit-form-line" style="width: 100%;">
                    <input type="text" name="" v-if="currentTab==5" v-model="addressSearchForm.city" placeholder="City">
                  </div>
                </div>
                <span style="flex:1;" ></span>
                <div style="flex:1;min-width: 40%;">
                  <h3 :class="['edit-form-title',{'empty-emptyTipsShaing-animate': showEmpty  && !addressSearchForm.country }]" >Country <span class="req-star">*</span></h3>
                  <div class="edit-form-line" style="width: 100%;">
                    <el-select v-model="addressSearchForm.country" placeholder="Country" style="width: 100%;">
                      <el-option
                        v-for="item in countryList"
                        :key="item.code"
                        :label="item.text"
                        :value="item.code">
                      </el-option>
                    </el-select>
                  </div>
                </div>
              </div>
              <!-- PC：Full Name 单独一行 -->
              <h3 v-if="!isMobile" :class="['edit-form-title',{'empty-emptyTipsShaing-animate': showEmpty && !form.nickName }]" >Full Name <span class="req-star">*</span></h3>
              <div v-if="!isMobile" class="edit-form-line">
                <input type="text" name="" v-if="currentTab==5" v-model="form.nickName" placeholder="Name">
              </div>
              <!-- Mobile：Country 单独一行 -->
              <div class="normal-form-line" v-if="isMobile" style="height: 65px;margin: 0px auto 20px;" >
                <div style="flex:1;min-width: 42%;">
                  <h3 :class="['edit-form-title',{'empty-emptyTipsShaing-animate': showEmpty  && !addressSearchForm.country }]" >Country <span class="req-star">*</span></h3>
                  <div class="edit-form-line">
                    <el-select v-model="addressSearchForm.country" placeholder="Country" style="width: 100%;">
                      <el-option
                        v-for="item in countryList"
                        :key="item.code"
                        :label="item.text"
                        :value="item.code">
                      </el-option>
                    </el-select>
                  </div>
                </div>
              </div>
              <!-- Mobile：Full Name 单独一行 -->
              <h3 v-if="isMobile" :class="['edit-form-title',{'empty-emptyTipsShaing-animate': showEmpty && !form.nickName }]" >Full Name <span class="req-star">*</span></h3>
              <div v-if="isMobile" class="edit-form-line">
                <input type="text" name="" v-if="currentTab==5" v-model="form.nickName" placeholder="Name">
              </div>
              <h3 :class="['edit-form-title',{'empty-emptyTipsShaing-animate': showEmpty && !form.email }]" >Email <span class="req-star">*</span></h3>
              <div class="edit-form-line">
                <input type="text" name="" v-if="currentTab==5" v-model="form.email" placeholder="Email">
              </div>

              <h3 :class="['edit-form-title',{'empty-emptyTipsShaing-animate': showEmpty  && !form.phone }]" >Phone Number <span class="req-star">*</span></h3>
              <div class="normal-form-line">
                <div class="area-box">
                  <PhoneBtn v-model="form.code"></PhoneBtn>
                </div>
                <div class="shadow-box" >
                  <input type="text" name="" v-if="currentTab==5" style="flex:1;" @keyup="form.phone=form.phone.replace(/\D/g,'')" v-model="form.phone" placeholder="Phone number" />
                </div>
              </div>

              <div class="btn-box">
                <!-- <button class="deleteBtn" ></button> -->
                <span style="flex:1;"></span>
                <button class="save-btn" @click="saveAddress">Save</button>
              </div>

            </template>
            <!-- 非英国地区 -->
            <template v-else>
              <h3 :class="['edit-form-title',{'empty-emptyTipsShaing-animate': showEmpty && !saveAddressForm.doorNumber }]" >
                House Number
              </h3>
              <div class="edit-form-line">
                <input type="text" name="" v-if="currentTab==5" v-model="saveAddressForm.doorNumber" placeholder="House Number">
              </div>
              <h3 :class="['edit-form-title',{'empty-emptyTipsShaing-animate': showEmpty && !addressSearchForm.locationName }]" >
                Street / Road Building Name
              </h3>
              <div class="edit-form-line">
                <input type="text" name="" v-if="currentTab==5" v-model="addressSearchForm.locationName" placeholder="Street / Road">
              </div>
              <h3 :class="['edit-form-title',{'empty-emptyTipsShaing-animate': showEmpty && !addressSearchForm.formattedAddress}]" >
                Address
              </h3>
              <div class="edit-form-line">
                <input type="text" name="" v-if="currentTab==5" v-model="addressSearchForm.formattedAddress" placeholder="Apartment, Road ">
              </div>
  
              <div class="normal-form-line" style="height: 65px;margin: 0px auto 20px;" >
                
                <div style="flex:1;min-width: 42%;">
                  <h3 :class="['edit-form-title',{'empty-emptyTipsShaing-animate': showEmpty  && !addressSearchForm.country }]" >Preferred Name</h3>
                  <div class="edit-form-line">
                    <input type="text" name="" v-if="currentTab==5" v-model="form.nickName" placeholder="Name">
                  </div>
                </div>
                <span style="flex:1;" ></span>
                <div style="flex:1;min-width: 58%;">
                  <h3 :class="['edit-form-title',{'empty-emptyTipsShaing-animate': showEmpty && !form.email }]" style="width: 100%;">Email</h3>
                  <div class="edit-form-line" style="width: 100%;">
                    <input style="font-size:14px" type="text" name="" v-if="currentTab==5" v-model="form.email" placeholder="Email">
                  </div>
                </div>
              </div>

              <h3 :class="['edit-form-title',{'empty-emptyTipsShaing-animate': showEmpty  && !form.phone }]" >Phone Number</h3>
              <div class="normal-form-line">
                <div class="area-box">
                  <PhoneBtn v-model="form.code"></PhoneBtn>
                </div>
                <div class="shadow-box" >
                  <input type="text" name="" v-if="currentTab==5" style="flex:1;" @keyup="form.phone=form.phone.replace(/\D/g,'')" v-model="form.phone" placeholder="Phone number" />
                </div>
              </div>

              <h3 :class="['edit-form-title']" >
                Note For Driver
              </h3>
              <div class="edit-form-line">
                <input type="text" name=""  v-model="addressSearchForm.deliveryInstrustion" placeholder="building name is cecil house">
              </div>

              <div class="btn-box">
                <!-- <button class="deleteBtn" ></button> -->
                <span style="flex:1;"></span>
                <button class="save-btn" @click="saveAddress">Save</button>
              </div>

            </template>



          </div>

        </div>

        <!-- 蒙层 -->
        <div class="loading-box" v-if="blockLoading">
          <el-skeleton :loading="blockLoading" animated>
            <template slot="template">
              <el-skeleton-item variant="rect" :style="{height: (currentTab<4?'500px': '730px')}" />
            </template>
            <div style="height: 400px"></div>
          </el-skeleton>
        </div>

        <!-- loading 蒙层 -->
        <div class="fetch-load-box" v-if="fetchLoading">
          <i class="el-icon-loading"></i>
        </div>
      </div>
    </div>

    <!-- 验证码滑块模块 -->
    <Verify
      @success="sendcodeMsg"
      :mode="'pop'"
      :captchaType="'blockPuzzle'"
      :imgSize="{ width: '330px', height: '155px' }"
      ref="verify"
    ></Verify>
  </div>
</template>

<script>
import { postGateway } from "@/request";
import PhoneBtn from "@/components/PhoneBtn.vue";
import Verify from "@/components/Verifition/Verify";
import LoginForm from "@/components/LoginForm.vue";
import BindPhone from "@/components/BindPhone.vue";
import debounce from '@/utils/debounce';
import CloudflareVerify from '@/components/CloudFlareVerify.vue';
import ForgotPassword from '@/components/ForgotPassword.vue';
import bus from "@/utils/bus.js";

export default {
  metaInfo: {},
  name: "Login",
  components: {
    PhoneBtn,
    Verify,
    LoginForm,
    BindPhone,
    CloudflareVerify,
    ForgotPassword
  },
  props: {
    transType: String,
    addAddress: Boolean,
    merchantId: [String, Number]
  },
  data() {
    return {
      inputFocus: false,
      currentTab: 4,
      blockLoading: true,
      keywords: '', // 搜索地址关键词
      focusNow: false,
      resultList: [],
      loading: false,
      itemLoading: null,
      addressSearchForm: {
        city: '',
        country: '',
        state: '',
        street: '',
        zipcode: '',
        formattedAddress: '',
        locationName: '',
        lat: '',
        lng: '',
        deliveryInstrustion: ''
      },
      userInfo: {
        nickName: '',
        emailAddress: '',
        firstName: '',
        contactPhone: ''
      },
      saveAddressForm: {
        fullName: '',
				clientId: null,
				contactPhone: '',
				dontDoorNum: false, // 是否 没有门牌号
				street: '',
				city: '',
				state: '', // 目前不知道是啥
				country: '',
				countryCode: '',
				ipAddress: "", // ip地址
				latitude: "", // 经度
				longitude: "", // 纬度
				doorNumber: '', // 门牌号
				locationName: "", //楼层信息
				asDefault: true, // 是否设为默认
				formattedAddress: '',  //格式化之后的地址
				zipcode: '',  //邮编
      },
      showEmpty: false,
      fetchLoading: false,
      countryList: [],
      useGoogleSearch: true,
      showForgotPasswordModal: false, // 显示忘记密码弹窗
      loginLoading: false, // 登录按钮loading状态
      showCloudflare: false, // 显示Cloudflare验证弹窗
      form: {
        verCode: '',
        nickName: '',
        email: '',
        phone: '',
        code: '+44'
      }
    };
  },
  computed: {
    cantLogin() {
      return this.form.verCode.length === 4;
    },
    isMobile() {
      return window.innerWidth < 950
    }
  },
  watch: {
    'addAddress': function(val) {
      if(val) {
        // this.$refs.carousel.setActiveItem(3);
        this.currentTab = 4;
      }
    },
    'showEmpty': function(val) {
      this.scrollToTarget();
      if(val) {
        setTimeout(() => {
          this.showEmpty = false;
        }, 4000);
      }
    }
  },
  mounted() {
    this.$nextTick(() => {
      if(this.addAddress) {  // 用于添加地址的时候
        this.currentTab = 4;
      } else {
        this.currentTab = 0;
      }
      setTimeout(() => {
        this.blockLoading = false;
      }, 300);
    });
    if(localStorage.getItem('token')) {
      this.checkUserPhoneBinding();
      this.getCountryList();
    }
    
  },
  methods: {
    // 设置加载状态
    setLoading(loading) {
      this.fetchLoading = loading;
    },
    
    // 设置登录加载状态
    setLoginLoading(loading) {
      this.loginLoading = loading;
    },
    
    // 检查用户手机号绑定状态
    checkUserPhoneBinding() {
      this.getUserInfo().then(() => {
        // 检查用户是否有手机号
        if (!this.userInfo.contactPhone || this.userInfo.contactPhone.trim() === '') {
          // 没有手机号，需要绑定
          this.nextTab(2); // 跳转到绑定手机号页面
        } else {
          // 有手机号，检查是否需要补充信息
          if (!this.userInfo.emailAddress) {
            // 没有邮箱，需要补充信息
            this.$emit('needFill', true);
            this.nextTab(3); // 跳转到补充信息页面
          } else {
            // 信息完整，登录完成
            if(!this.addAddress) {
              this.$emit('loginDone', true);
              this.$emit('needFill', false);
            } else {
              // 如果是添加地址模式，跳转到地址搜索页面
              this.nextTab(4);
            }
          }
        }
      }).catch(() => {
        // 如果获取用户信息失败，显示登录表单
        this.currentTab = 0;
      });
    },
    
    // 处理LoginForm的登录成功事件
    handleLoginSuccess() {
      this.getUserInfo().then(() => {
        this.fetchLoading = false;
        /* eslint-disable */ 
        if (this.userInfo.emailAddress) {  //如果有邮箱 说明老用户 手机用户跳过补充信息页面
          this.$emit('loginDone', true);
          this.$emit('needFill', false);
          this.getUserInfo();
        } else {
          this.$emit('needFill', true);
          this.nextTab(3);
        }
      });
      this.$nextTick(() => {
        this.getCountryList();
      });
    },
    
    // 处理绑定手机号完成
    handleBindDone(success) {
      if (success) {
        // 绑定成功，继续流程
        this.getUserInfo().then(() => {
          if (this.userInfo.emailAddress) {
            // 有邮箱，登录完成
            if(!this.addAddress) {
              this.$emit('loginDone', true);
              this.$emit('needFill', false);
            } else {
              // 如果是添加地址模式，跳转到地址搜索页面
              this.nextTab(4);
            }
          } else {
            // 没有邮箱，需要补充信息
            this.$emit('needFill', true);
            this.nextTab(3); // 跳转到补充信息页面
          }
        }).catch(() => {
          this.$message.error('获取用户信息失败');
        });
      } else {
        // 绑定失败，返回登录页面
        this.currentTab = 0;
      }
    },
    
    // 处理需要绑定手机号
    handleNeedBindPhone() {
      // 跳转到绑定手机号页面
      this.nextTab(2);
    },
    
    // 处理LoginForm的短信发送成功事件
    handleSmsSuccess() {
      if (this.currentTab < 1) {
        this.nextTab(1);
      }
    },
    
    // 处理LoginForm的gotCode事件
    handleGotCode() {
      this.gotCode();
    },
    
    // 处理短信发送成功
    onSmsSuccess() {
      if (this.currentTab < 1) {
        this.nextTab(1);
      }
    },
    
    // 关闭 Cloudflare 弹层
    closeCloudflare() {
      this.showCloudflare = false;
      this.resetCode();
    },
    
    // 处理验证码发送成功
    sendcodeMsg() {
      this.showCloudflare = false;
      this.onSmsSuccess();
    },
    
    // 重置验证码
    resetCode() {
      this.form.verCode = '';
    },
    
    // 显示忘记密码弹窗
    showForgotPassword() {
      this.showForgotPasswordModal = true;
    },
    
    // 关闭忘记密码弹窗
    closeForgotPassword() {
      this.showForgotPasswordModal = false;
    },
    
    // 跳转到注册页面
    goToSignup() {
      this.$router.push({
        path: '/signup',
        query: { from: 'checkout' }
      });
    },
    gotCode() {
      if (!this.form.phone.trim()) {
        this.$message({
          message: "Please enter phone number",
          type: "warning",
        });
        return;
      }
      if (this.form.phone.indexOf(44) === 0) {
        this.$message({
          message: "Without the '44' country code.",
          type: "warning",
        });
        return;
      }
      this.currentTab = 1;
    },
    cantFindAd() {
      let obj = {
        formattedAddress: '',
        locationName: '',
        zipcode: '',
        city: '',
        latitude: '',
        longitude: '',
        lat: '',
        lng: '',
        street: '',
        country: this.$isUk?'United Kingdom':'Ireland',
        countryCode: this.$isUk?'GB':'IRE',
        deliveryInstrustion: ''
      }
      this.addressSearchForm = obj;
      this.nextTab(5)
    },
    changTab(index) {
      this.currentTab = index;
    },
    goBack() {
      if(this.addAddress) {
        this.$emit('addressDone', false);
        return
      }
      this.$router.go(-1);
    },
    gotoPrivate() {
      this.$router.push("/Privacy-Policy");
    },
    preTab() {  // 默认tab设置
      // When adding address from checkout:
      // - from tab 5 (form) go back to tab 4 (search)
      // - from tab 4 (search) exit back to checkout display (parent)
      if (this.addAddress) {
        if (this.currentTab === 5) {
          this.currentTab = 4;
          return;
        }
        if (this.currentTab === 4) {
          this.$emit('addressDone', false);
          return;
        }
      }

      if (this.currentTab > 0) {
        this.currentTab--;
      }
    },
    nextTab(val) {
      if(val) {
        this.currentTab = val;
      } else {
        this.currentTab++;
      }
    },
    login() {  // 登录

      if(!this.form.verCode.length) {
        return
      }
      let { code, phone } = this.form;
      this.fetchLoading = true;
      postGateway({
        url: "/sys/client/clientLogin",
        method: "POST",
        data: {
          phone: code + phone,
          code: this.form.verCode,
          type: "web",
        },
      }).then((res) => {
        if (res.data.token) {
          let { token, refreshToken, clientId } = res.data;
          localStorage.setItem("token", token);
          localStorage.setItem("refreshToken", refreshToken);
          localStorage.setItem("clientId", clientId);
          localStorage.setItem("aeClient", clientId);
          bus.$emit("login"); // 通知header登陆了
          
          this.getUserInfo().then(res=>{
            this.fetchLoading = false;
            /* eslint-disable */ 
            if(this.userInfo.emailAddress) {  //如果有邮箱 说明老用户 手机用户跳过补充信息页面
              this.$emit('loginDone', true)
              this.getUserInfo()
            } else {
              this.$emit('needFill', true)
              this.nextTab(2);
            }
          })
          this.$nextTick(()=>{
            this.getCountryList();
          })
        }
      }).catch((err)=>{
        this.$message.error(err.msg)
        this.fetchLoading = false;
      })

    },
    getUserInfo() {
      return postGateway({
        url: '/customerApp/center/getDetail',
        method: 'GET',
        data: {
          clientId: localStorage.getItem('clientId')
        }
      }).then(res=>{
        this.userInfo = res.data;
        this.form.nickName = res.data.firstName || res.data.nickName;
        this.form.email = res.data.emailAddress;
        // 补全手机号
        if(res.data.contactPhone.indexOf('+44') == 0) {
					this.form.phone = res.data.contactPhone.replace('+44','')
					this.form.code = '+44';
				}
        if(res.data.contactPhone.indexOf('+353') == 0) {
					this.form.phone = res.data.contactPhone.replace('+353','')
					this.form.code = '+353';
				}
				if(res.data.contactPhone.indexOf('+86') == 0) {
					this.form.phone = res.data.contactPhone.replace('+86','');
					this.form.code = '+86';
				}
        if(res.data.contactPhone.indexOf('44') == 0) {
					this.form.phone = res.data.contactPhone.replace('44','')
					this.form.code = '+44';
				}
        if(res.data.contactPhone.indexOf('353') == 0) {
					this.form.phone = res.data.contactPhone.replace('353','')
					this.form.code = '+353';
				}
				if(res.data.contactPhone.indexOf('86') == 0) {
					this.form.phone = res.data.contactPhone.replace('86','');
					this.form.code = '+86';
				}
      })
      .catch()
    },
    getCountryList() {
      postGateway({
        url: '/districtCode/getDistrictSelect',
        method: 'GET',
        data: {
          level: 1,
        }
      }).then(res=>{
        this.countryList = res.data
      })
      .catch()
    },
    submitNameInfo() {  // 补充姓名 邮箱
      // 补充用户信息 - 登录之后
      let { nickName, email } = this.form;
      
      this.fetchLoading = true;
      let nameArr = nickName.split(' ');
      postGateway({
        url: '/customer/atClient/savePersonalInfo',
        method: 'POST',
        data: {
					clientId: localStorage.getItem('clientId'),
					avatar: '',
          nickName: nickName,
          firstName: nameArr[0],
          lastName: nameArr.length>1?nameArr[1]:'',
          emailAddress: email,
          contactPhone: this.userInfo.contactPhone || '', // 使用用户已有的手机号
				}
      }).then(res=>{
        this.fetchLoading = false;
        this.$emit('loginDone',true)
        this.$emit('needFill', false)
        // 跳转到搜索地址页面
        this.nextTab(5);
      }).catch(()=>{
        this.fetchLoading = false;
      })
    },
    // 搜索地址相关
    inputNow() {
      this.resultList = [];
      this.loading = true;
      this.focusNow = true;
      debounce(() => {
        this.googlePreSearch();
      }, 500);
    },
    googlePreSearch() {  // 自动补全地址
      if(this.$isUk && !this.useGoogleSearch) {
				postGateway({
					url: `/customerApp/addressioSearch/autocomplete`,
					method: 'GET',
					data: {
						keyword: this.keywords
					}
				}).then(res=>{
					this.loading = false;
					this.resultList = res.data.suggestions.map(x=>({
            ...x,
            content: x.description || x.address,
            place_id: x.id,
            type: "location",
          }));
				})
				.catch(err=>{
					this.loading = false;
				})
				return
			}
      postGateway({
        method: "GET",
        url: "/customerWeb/googleSearch/autocomplete",
        data: { keyword: this.keywords },
      })
      .then((res) => {
        this.resultList = this.resultList.concat(
          res.data.predictions.map((x) => {
            return {
              ...x,
              content: x.description,
              type: "location",
            };
          })
        );
        this.loading = false;
      })
      .catch(() => {
        this.loading = false;
      });
    },
    // 根据结果跳转下一步
    normalSearch(item) {
      this.googleSearch(item);
    },
    googleSearch(item) {
      this.itemLoading = item.place_id;

      if(this.$isUk && !this.useGoogleSearch) {
				postGateway({
					url: `/customerApp/addressioSearch/get`,
					method: 'GET',
					data: {
						id: item.id
					}
				}).then(res=>{
					this.itemLoading = '';
          if (res.code == 200) {
            let { formatted_address, postcode, longitude, latitude,town_or_city, country, line_1, deliveryInstrustion  } = res.data;
            let obj = {
              formattedAddress: formatted_address.join(','),
              zipcode: postcode,
              city: town_or_city,
              latitude: latitude,
              longitude: longitude,
              lat: latitude,
              lng: longitude,
              street: line_1,
              country: country,
              locationName: line_1 || '',
              countryCode: 'GB',
              deliveryInstrustion: deliveryInstrustion?deliveryInstrustion:''
            }
            this.addressSearchForm = obj;
            this.nextTab(5)
          } else {
            this.$message.error("Error happen...");
          }
					
				})
				.catch(err=>{
					// 搜索地址报错
				})
				return
			}

      postGateway({
        method: "GET",
        url: "/customerApp/googleSearch/placeGeoCode",
        data: {
          keyword: "",
          placeId: item.place_id,
        },
      }).then((res) => {
        this.itemLoading = '';
        if (res.code == 200) {
          this.addressSearchForm = {
            ...res.data,
            locationName: res.data.street || '',
            deliveryInstrustion: ''
          };
          this.nextTab(5)
        } else {
          this.$message.error("Error happen...");
        }
      }).catch(err=>{
        this.itemLoading = '';
      })
    },
    scrollToTarget() {
      let dom = document.querySelector('.payment-box');
      let target = dom.offsetTop-120;
      if(window.innerWidth < 950) {
        target = dom.offsetTop - 100;
      }
      document.body.scrollTop = document.documentElement.scrollTop  = target;
    },
    // 保存用户地址表格
    saveAddress() {
      
      let { code, phone, nickName } = this.form;
      let { city, country, state, street, zipcode ,formattedAddress, locationName, lat, lng, deliveryInstrustion } = this.addressSearchForm;
      let countryCode = ""
      if(country == 'England' || country == 'Scotland') {
        countryCode = 'GB'
      }
      // let countryName = this.countryList.filter(x=>x.code===country)[0].text
      if((!this.saveAddressForm.doorNumber && !this.saveAddressForm.dontDoorNum)) {
				this.$message.info('Please fill the Door Number')
        this.showEmpty = true;
				return
			}

      // Street（locationName）必填：英国/非英国都需要
      if(!this.addressSearchForm.locationName) {
        this.$message.info('Please fill the Street / Road');
        this.showEmpty = true;
				return
			}


      let param = {
        city, state, street, zipcode ,
        formattedAddress,
        locationName,
        latitude: lat,
        longitude: lng,
        lat, 
        lng,
        contactPhone: code + phone,
        fullName: nickName,
        clientId: localStorage.getItem('clientId'),
        country: country,
        countryCode: countryCode || 'GB',
        isDoorNumber: this.saveAddressForm.dontDoorNum ? 0 : 1,
        asDefault: this.saveAddressForm.asDefault ? 1 : 0,
        doorNumber: this.saveAddressForm.doorNumber,
        deliveryInstrustion
      }

      // 英国地区的地址同步一下 locationName
      if(this.$isUk && !param.locationName && param.street) {
        param.locationName = param.street
      }

      if(!param.fullName) {
				this.$message.info('Please fill the Full Name')
        this.showEmpty = true;
				return
			}
			
			if(!phone) {
				this.$message.info('Please fill the Phone Number')
        this.showEmpty = true;
				return
			}

      let phoneCode = this.form.code.replace('+','');
      if(this.form.phone.indexOf(phoneCode) === 0) {
        this.$message({
          message: "Please check phone number width '" + phoneCode + "'",
          type: "warning",
        });
        return;
      }
			
			// if(!param.street) {
			// 	this.$message.info('Please fill the Addres')
      //   this.showEmpty = true;
			// 	return
			// }
			
			if(!param.city && this.$isUk) {
				this.$message.info('Please fill the City')
        this.showEmpty = true;
				return
			}
			if(!param.countryCode && this.$isUk) {
				this.$message.info('Please fill the Country')
        this.showEmpty = true;
				return
			}
			if(!param.zipcode && this.$isUk) {
				this.$message.info('Please fill the Postcode')
        this.showEmpty = true;
				return
			}
      this.fetchLoading = true;
      postGateway({
        url: '/customer/address/add',
        method: 'POST',
        data: param
      }).then(res=>{
        this.fetchLoading = false;
        this.$emit('loginDone',true)
        /* eslint-disable */
        // if(!this.userInfo.emailAddress  || !this.userInfo.firstName) {
        //   this.submitNameInfo()
        // }
      })
      .catch(()=>{
        this.fetchLoading = false;
      })

      
      

    }
  },
};
</script>

<style lang="scss" scoped>
$mainColor: #aa0bc0;
$greenColor: #26d07c;
$yellowColor: #ffa132;
.req-star {
  color: #ff4d4f;
  font-size: 12px;
  font-weight: 600;
  margin-left: 4px;
}
.cloud-box {
  padding-left: 15px;
}
@media screen and (min-width: 950px) {
  .cloud-box{
    padding-left: 35%;
  }
}
.form-box {
  // width: 780px;
  min-height: 580px;
  background: #fff;
  border-radius: 16px;
  padding: 12px 40px;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.12);
  input {
    font-weight: 600;

    &::placeholder {
      font-weight: 400;
    }
  }

  h2 {
    font-weight: 800;
    color: #000;
    font-size: 35px;
    text-align: center;
    margin-top: 0;
    margin-bottom: 8px;
  }
  p {
    font-size: 18px;
    text-align: center;
    margin: 0;
    .under-line {
      text-decoration: underline;
      margin: 0;
      cursor: pointer;
      color: #2885e2;
    }
  }

  .input-box {
    margin-top: 28px;
    display: flex;
    align-items: center;
    justify-content: center;
    max-width: 500px;
    margin-left: auto;
    margin-right: auto;

    .area-box {
      height: 56px;
      width: 114px;
      margin-right: 10px;
      border-radius: 12px;
      box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
    }
    .input {
      height: 56px;
      flex: 1;
      box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
      border-radius: 12px;
      padding-left: 20px;
      font-size: 20px;
      font-weight: 600;
      &::placeholder {
        font-weight: 500;
      }
    }
    .shadow-box {
      flex: 1;
      box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
      border-radius: 12px;
      position: relative;
      
      &.full-width {
        flex: 1;
        margin-right: 0;
      }
      
      input {
        height: 56px;
        width: 100%;
        border: none;
        outline: none;
        padding-left: 20px;
        padding-right: 50px;
        font-size: 20px;
        font-weight: 600;
        background: transparent;
        &::placeholder {
          font-weight: 500;
        }
      }
      
      .password-toggle {
        position: absolute;
        right: 15px;
        top: 50%;
        transform: translateY(-50%);
        cursor: pointer;
        color: #999;
        font-size: 18px;
        &:hover {
          color: #666;
        }
      }
    }
  }

  // 登录方式选择器样式
  .login-method-selector {
    display: flex;
    margin: 20px 0;
    border-radius: 8px;
    overflow: hidden;
    box-shadow: 0px 2px 8px rgba(0, 0, 0, 0.1);
    
    .method-option {
      flex: 1;
      display: flex;
      align-items: center;
      justify-content: center;
      padding: 15px 20px;
      background: #f8f9fa;
      cursor: pointer;
      transition: all 0.3s ease;
      border-right: 1px solid #e9ecef;
      
      &:last-child {
        border-right: none;
      }
      
      i {
        margin-right: 8px;
        font-size: 18px;
        color: #666;
      }
      
      span {
        font-size: 16px;
        font-weight: 500;
        color: #666;
      }
      
      &.active {
        background: #09CA6A;
        color: white;
        
        i, span {
          color: white;
        }
      }
      
      &:hover:not(.active) {
        background: #e9ecef;
      }
    }
  }

  // 账号类型选择器样式
  .account-type-selector {
    display: flex;
    margin: 10px 0;
    border-radius: 4px;
    overflow: hidden;
    box-shadow: 0px 1px 3px rgba(0, 0, 0, 0.08);
    max-width: 200px;
    margin-left: auto;
    margin-right: auto;
    border: 1px solid #e0e0e0;
    
    .type-option {
      flex: 1;
      display: flex;
      align-items: center;
      justify-content: center;
      padding: 6px 10px;
      background: #ffffff;
      cursor: pointer;
      transition: all 0.2s ease;
      border-right: 1px solid #e0e0e0;
      
      &:last-child {
        border-right: none;
      }
      
      i {
        margin-right: 4px;
        font-size: 12px;
        color: #888;
      }
      
      span {
        font-size: 12px;
        font-weight: 400;
        color: #666;
      }
      
      &.active {
        background: #f0f8ff;
        border-color: #4a90e2;
        
        i, span {
          color: #4a90e2;
        }
      }
      
      &:hover:not(.active) {
        background: #f8f9fa;
      }
    }
  }

  .check-box {
    margin-top: 20px;
    display: flex;
    font-size: 18px;
    display: flex;
    align-items: center;
    flex-wrap: wrap;

    :deep(.el-checkbox__inner) {
      background-color: #dcdfe6;
    }
    :deep(
        .el-checkbox__input.is-checked .el-checkbox__inner,
        .el-checkbox__input.is-indeterminate .el-checkbox__inner
      ) {
      background-color: #09ca6a;
      border-color: #09ca6a;
    }
    :deep(.el-checkbox__inner) {
      transform: scale(1.4);
    }
    span {
      margin-left: 15px;
      cursor: pointer;
    }
    p {
      margin-top: 10px;
      display: block;
      font-size: 14px;
      line-height: 20px;
      color: #474747;
      text-align: left;
      .under-line {
        text-decoration: underline;
        margin: 0;
        cursor: pointer;
        color: #2885e2;
      }
    }
  }
  @keyframes shakingAnimation {
		0% {
			transform: translateX(-3%); 
			color: red;
		}
		10% {
			transform: translateX(63); 
			color: red;
		}
		20% {
			transform: translateX(-2%); 
			color: red;
		}
		30% {
			transform: translateX(2%); 
			color: red;
		}
		40% {
			transform: translateX(-1%); 
			color: red;
		}
		50% {
			transform: translateX(1%); 
		}
	}
  .shaking {
		color: rgb(199, 12, 12);
		transform: translateX(0); 
		animation: shakingAnimation 1s ease-in-out forwards;
	}
  .sign-btn {
    margin: 20px auto 5px;
    height: 58px;
    width: 220px;
    background-color: #09ca6a;
    color: #fff;
    font-size: 16px;
    letter-spacing: 1px;
    font-weight: 600;
    border-radius: 29px;
    box-shadow: 0 4px 12px rgba(9, 202, 106, 0.3);
    transition: all .3s ease;
    cursor: pointer;
    border: none;
    outline: none;
    display: flex;
    align-items: center;
    justify-content: center;
    &:hover {
      background-color: #0fda74;
      box-shadow: 0 6px 20px rgba(9, 202, 106, 0.4);
      transform: translateY(-2px);
    }
    &:active {
      transform: translateY(0);
    }
  }
  .being-send {
    height: 28px;
    font-size: 15px;
    margin: 10px auto 0;
    text-decoration: underline;
    cursor: pointer;
    text-align: center;
    display: block;
    &:active {
      color: #6f7577;
    }
  }
  
  // 底部链接容器
  .bottom-links-container {
    margin-top: 20px;
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 15px;
  }
  
  .forgot-password-link {
    font-size: 14px;
    text-decoration: underline;
    cursor: pointer;
    color: #2885e2;
    transition: color 0.3s ease;
    
    &:hover {
      color: #1a6bb8;
    }
    
    &:active {
      color: #0f4a7a;
    }
  }
  
  .signup-link-container {
    text-align: center;
    font-size: 14px;
    color: #666;
    
    .signup-link {
      color: #d22f21;
      font-weight: bold;
      cursor: pointer;
      text-decoration: underline;
      margin-left: 5px;
      
      &:hover {
        color: #b01e1a;
      }
    }
  }
  
  // Google登录区域样式
  .google-login-section {
    margin-top: 20px;
    width: 100%;
    
    .divider {
      display: flex;
      align-items: center;
      margin: 20px 0;
      
      &::before,
      &::after {
        content: '';
        flex: 1;
        height: 1px;
        background: #e0e0e0;
      }
      
      span {
        padding: 0 15px;
        color: #999;
        font-size: 14px;
        background: #fff;
      }
    }
  }
  .disable-btn {
    background-color: #999;
    &:hover {
      background-color: #999;
      box-shadow: 0px 5px 10px #6f7577;
    }
  }
  .ver-code {
    margin: 30px auto 20px;
    display: flex;
    position: relative;
    width: 400px;
    overflow: visible;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
    border-radius: 12px;
    justify-content: center;
    background: #fff;
    input {
      height: 58px;
      z-index: 10;
      font-size: 30px;
      width: 400px;
      background-color: transparent;
      box-sizing: border-box;
      border-radius: 12px;
      letter-spacing: 40px;
      text-align: center;
      font-weight: 600;
      border: none;
      outline: none;
      padding: 0 20px;

      &::placeholder {
        letter-spacing: normal;
        font-weight: 400;
        color: #c6c8cb;
        font-size: 25px;
      }
    }
    .mask-box {
      display: flex;
      display: none;
      justify-content: center;
      width: 400px;
      .font-box {
        height: 65px;
        min-width: 68px;
        border-radius: 4px;
        margin-right: 30px;
        box-shadow: 0px 3px 6px #8f9698;
        background-color: #fff;
        font-size: 30px;
        color: #000;
        display: inline-flex;
        align-items: center;
        justify-content: center;
        position: relative;

        .ol-line {
          height: 40px;
          width: 2px;
          border-radius: 1px;
          background-color: #000;
          animation: breath 1.2s ease-in-out infinite alternate forwards;
          position: absolute;
          left: 22%;
          top: 50%;
          transform: translateY(-50%);
          z-index: 20;
        }
      }
    }
  }

  .resend-btn {
    height: 32px;
    padding: 0 20px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 18px;
    margin: 0 auto;
    cursor: pointer;
    color: $mainColor;
    text-align: center;
    border-radius: 16px;
    transition: all 0.3s ease;
    &:hover:not(.disabled) {
      background: rgba(170, 11, 192, 0.1);
      transform: translateY(-1px);
    }
    &.disabled {
      color: #999;
      cursor: not-allowed;
    }
  }

  .name-tips {
    margin: 24px 0 40px;
  }

  .form-line {
    margin: 0 auto 20px;
    display: flex;
    width: 60%;
    box-shadow: 0px 2px 12px rgba(16, 16, 16, 0.15);
    height: 48px;
    font-size: 18px;
    color: #000;
    border-radius: 4px;
    overflow: hidden;

    input {
      height: 100%;
      width: 100%;
      padding-left: 20px;
      color: #000;
      font-size: 20px;
    }
  }

  .swtich-box {
    display: flex;
    justify-content: flex-end;
    margin-top: 40px;
    margin-right: 30px;
    span {
      font-size: 14px;
      font-weight: bold;
      margin-right: 12px;
      display: inline-flex;
      align-items: center;
      cursor: default;

      i {
        margin: 0 4px;
      }
    }
  }

  .form-address-line {
    margin: 10px auto 20px;
    display: flex;
    height: 48px;
    font-size: 18px;
    width: 90%;
    position: relative;

    .input-address-box {
      flex: 1;
      display: inline-flex;
      align-items: center;
      height: 100%;
      box-shadow: 0px 2px 12px rgba(16, 16, 16, 0.15);
      border-radius: 4px;
      margin-top: 0;
      padding-left: 20px;
      .el-icon-location {
        color: #000;
        margin-right: 12px;
        font-size: 20px;
      }
      input {
        flex: 1;
        height: 100%;
        font-size: 18px;
        font-weight: 600;
        color: #000;
      }
    }
    
    .search-btn {
      background: #09CA6A;
      box-shadow: 0px 2px 12px rgba(16, 16, 16, 0.15);
      color: #fff;
      display: flex;
      align-items: center;
      margin-left: 10px;
      height: 100%;
      padding: 0 20px;
      white-space: nowrap;
      font-size: 15px;
      font-weight: 600;
      border-radius: 4px;
      cursor: pointer;

      .el-icon-search {
        height: 20px;
        width: 20px;
        margin-right: 8px;
      }
    }

    .expand-box {
      position: absolute;
      width: 90%;
      height: 0px;
      top: 50px;
      left: 12px;
      background: rgba(255, 255, 255, 0.95);
      padding: 20px 0;
      height: 0px;
      opacity: 0;
      transition: all 0.8s ease-in-out 0s;
      box-shadow: 0px 2px 12px rgba(16, 16, 16, 0.15);

      .search-item {
        height: 50px;
        display: flex;
        align-items: center;
        border-bottom: 1px solid #e9e9e9;
        padding: 0 20px;
        cursor: pointer;

        .el-icon-loading {
          font-size: 18px;
          color: #aa0bc0;
          font-weight: bold;
        }

        &:hover {
          background-color: rgba(236, 230, 230, 0.95);
        }

        span {
          flex: 1;
        }

        img {
          height: 18px;
          width: 25px;
        }
      }
    }

    .load-box {
      height: 100%;
      width: 100%;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      .loader {
        width: 48px;
        height: 48px;
        border: 5px solid #fff;
        border-bottom-color: #ff3d00;
        border-radius: 50%;
        display: inline-block;
        box-sizing: border-box;
        animation: rotation 1s linear infinite;
      }

      @keyframes rotation {
        0% {
          transform: rotate(0deg);
        }
        100% {
          transform: rotate(360deg);
        }
      }
    }

    .empty-btn {
      margin: 10px auto;
      height: 60px;
      background-color: #02c757;
      border-radius: 4px;
      width: 300px;
      font-size: 18px;
      color: #fff;
      font-weight: bold;
      display: flex;
      align-items: center;
      justify-content: center;
      cursor: pointer;
    }

    .expand-box-active {
      height: 280px;
      opacity: 1;
      overflow-y: scroll;
    }

  }

  .edit-form-line {
    margin: 0 auto;
    width: 95%;
    height: 40px;
    display: flex;
    border-radius: 4px;
    overflow: hidden;
    align-items: center;
    box-shadow: 0px 2px 12px rgba(16, 16, 16, 0.15);

    input {
      height: 100%;
      width: 100%;
      padding-left: 20px;
      font-size: 16px;
    }
  }

  .normal-form-line {
    display: flex;
    align-items: center;
    width: 95%;
    height: 40px;
    font-weight: 600;
    margin: 12px auto 0;

    .area-box {
      box-shadow: 0px 2px 12px rgba(16, 16, 16, 0.15);
      margin-right: 20px;
      border-radius: 6px;
    }

    .check-tips {
      margin-left: 10px;
      white-space: nowrap;
      font-size: 15px;
    }

    input {
      height: 100%;
      padding-left: 20px;
      font-size: 16px;
    }
    .shadow-box {
      flex: 1;
      box-shadow: 0px 4px 4px rgba($color: #000000, $alpha: 0.2);
      height: 100%;
      input {
        width: 100%;
        flex: unset;
      }
    }

    :deep(.el-checkbox__inner) {
      background-color: #dcdfe6;
    }
    :deep(
        .el-checkbox__input.is-checked .el-checkbox__inner,
        .el-checkbox__input.is-indeterminate .el-checkbox__inner
      ) {
      background-color: #09ca6a;
      border-color: #09ca6a;
    }
    :deep(.el-checkbox__inner) {
      transform: scale(1.4);
    }
  }

  .edit-form-title {
    width: 95%;
    font-weight: 600;
    margin: 16px auto 8px;
  }

  // Desktop spacing tune: keep mobile layout unchanged.
  @media (min-width: 768px) {
    .edit-form-title {
      margin: 12px auto 6px;
    }

    .normal-form-line {
      margin: 8px auto 0;
      height: 38px;
    }

    .edit-form-line {
      height: 38px;
    }

    .edit-form-line input,
    .normal-form-line input {
      font-size: 15px;
      padding-left: 16px;
    }
  }

  .btn-box {
    width: 98%;
    display: flex;
    margin-top: 40px;
    padding-bottom: 5px;
    .save-btn {
      height: 48px;
      padding: 0 40px;
      border-radius: 24px;
      background: #09CA6A;
      color: #fff;
      font-weight: bold;
      font-size: 18px;
      display: flex;
      align-items: center;
      justify-content: center;
      box-shadow: 0px 2px 12px rgba(16, 16, 16, 0.15);
      cursor: pointer;
      transition: all .2s ease-in-out;

      &:hover {
        background: #08b35e;
      }
    }
  }

  @keyframes breath {
    0% {
      opacity: 1;
    }
    50% {
      opacity: 0;
    }
    100% {
      opacity: 1;
    }
  }
  .top-box {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    padding: 20px;

    i {
      font-size: 26px;

      color: #000;
      cursor: pointer;
      transition: all ease-in 0.2s;
      text-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25),
        0px 4px 4px rgba(0, 0, 0, 0.25);
      &:hover {
        color: $mainColor;
      }
    }
    .back {
      position: relative;
      left: -30px;
      cursor: pointer;
    }
    .close {
      position: relative;
      right: -40px;
    }
  }

  .slide-box {
    position: relative;
    .loading-box {
      position: absolute;
      top: 0;
      left: 0;
      height: 500px;
      width: 100%;
      z-index: 50;
    }
    .fetch-load-box {
      display: flex;
      align-items: center;
      justify-content: center;
      position: absolute;
      top: 0;
      left: 0;
      height: 100%;
      width: 100%;
      z-index: 51;
      background: rgba(255, 255, 255, 0.8);

      .el-icon-loading {
        font-size: 35px;
      }
    }
  }

  :deep(.el-select .el-input .el-input__inner) {
    font-weight: 600!important;
    color: #000;
  }
}

@media screen and (min-width: 1300px) and (max-width: 1550px) {
  // 默认宽度盒子
  .input-box {
    zoom: 0.8
  }
  .check-box {
    padding-left: 0!important;
  }
  .sign-btn, .being-send {
    margin-left: 0;
  }
  .section-login { 
    .form-box .slide-box{
      .ver-code {
        width: 380px;
      }
    }
  }
}

@media screen and (max-width: 950px) {
  .section-login {
    margin-right: 0px!important;
    .form-box {
      padding: 12px 30px;
      .slide-box {
        h2 {
          font-size: 20px;
        }
        p {
          font-size: 14px;
        }
        .input-box {
          margin-top: 20px;
          .area-box {
            height: 40px;
            width: 82px;
          }
          .input  {
            z-index: 10;
            height: 40px;
            font-size: 14px;
            min-width: 140px;
          }
          .shadow-box {
            flex: 1;
            height: 100%;
            input {
              width: 100%;
              flex: unset;
              padding-left: 0;
              text-align: center;
            }
          }
        }
        .check-box {
          padding-left: 0;
        }

        .ver-code {
          width: 94%;
          // padding-left: 25px;
          input {
            width: 100%;
          }
          .mask-box {
            width: 100%;
            // padding-left: 15px;
            .font-box {
              height: 45px;
              min-width: 48px;
              font-size: 25px;
            }
          }
        }
        .sign-btn {
          width: 96%!important;
        }
        .confirm-btn {
          width: unset!important;
          zoom: 0.8;
        }
        .name-tips {
          margin: 12px 0 20px;
        }

        .swtich-box {
          margin-right: 0px;
        }
        .form-address-line {
          width: 100%;
          flex-direction: column;
          height: auto;
          .input-address-box {
            height: 48px;
            flex: unset;
            input {
              flex: unset;
              width: 100%;
            }
          }
          .expand-box {
            width: 100%;
            padding: 0;
            left: 0%;
            .search-item {
              height: unset;
              padding: 10px 5px 10px 20px;
              img {
                height: unset;
                width: 13px;
                margin-left: 10px;
              }
            }
          }
          .search-btn {
            margin-top: 25px;
            height: 48px;
            margin-left: 0px;
            justify-content: center;
            .text {
              flex: 1;
              text-align: center;
              padding-right: 20px;
              text-align: center;
              font-size: 20px;
            }
          }
        }

      }
      .sign-btn {
        margin: 20px auto 0!important;
      }
      .being-send {
        margin: 10px auto 0!important;
      }
      
      .forgot-password-container {
        padding-right: 10px;
        margin-top: 10px;
      }
      
      .forgot-password-link {
        font-size: 13px;
      }
      .form-line {
        width: 90%;
        height: 40px;
      }
      .normal-form-line {
        flex-wrap: wrap;
        display: flex;
        .check-tips {
          font-size: 16px;
        }
      }
      
      .login-method-selector {
        margin: 15px 0;
        
        .method-option {
          padding: 12px 15px;
          
          i {
            font-size: 16px;
            margin-right: 6px;
          }
          
          span {
            font-size: 14px;
          }
        }
      }
      
      .account-type-selector {
        margin: 8px auto;
        max-width: 160px;
        display: flex;
        justify-content: center;
        
        .type-option {
          padding: 5px 8px;
          
          i {
            font-size: 10px;
            margin-right: 3px;
          }
          
          span {
            font-size: 10px;
          }
        }
      }
    }
  }
  
}

// Cloudflare 弹层样式
.cloudflare-modal {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 9999;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20px;
  box-sizing: border-box;
  
  .cloudflare-overlay {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.6);
    backdrop-filter: blur(4px);
  }
  
  .cloudflare-content {
    position: relative;
    background: #fff;
    border-radius: 16px;
    box-shadow: 0 20px 60px rgba(0, 0, 0, 0.4);
    max-width: 480px;
    width: 100%;
    max-height: 85vh;
    overflow: hidden;
    animation: modalSlideIn 0.4s cubic-bezier(0.34, 1.56, 0.64, 1);
    transform-origin: center;
    
    .cloudflare-header {
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 24px 28px;
      border-bottom: 1px solid #e9ecef;
      background: linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%);
      
      h3 {
        margin: 0;
        font-size: 20px;
        font-weight: 700;
        color: #2c3e50;
        display: flex;
        align-items: center;
      }
      
      .close-btn {
        background: none;
        border: none;
        font-size: 22px;
        color: #6c757d;
        cursor: pointer;
        padding: 8px;
        border-radius: 8px;
        transition: all 0.3s ease;
        display: flex;
        align-items: center;
        justify-content: center;
        width: 36px;
        height: 36px;
        
        &:hover {
          background: #e9ecef;
          color: #495057;
          transform: scale(1.1);
        }
      }
    }
    
    // Cloudflare 组件容器
    :deep(.cloudflare-verify) {
      padding: 24px 28px 28px;
      text-align: center;
      
      .cloudflare-widget {
        margin: 0 auto;
        border-radius: 8px;
        overflow: hidden;
      }
    }
  }
}

@keyframes modalSlideIn {
  0% {
    opacity: 0;
    transform: scale(0.8) translateY(-30px);
  }
  50% {
    opacity: 0.8;
    transform: scale(1.05) translateY(-5px);
  }
  100% {
    opacity: 1;
    transform: scale(1) translateY(0);
  }
}
</style>
